<ng-container slot="content">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="row justify-content-center" [ngClass]="routeAnimationsElements">
          <div class="col-md-8 pb-10">
            <!-- Con mat-card -->
            <mat-card *ngIf="matCard">
              <mat-tab-group>
                <mat-tab label="Información">
                  <div class="flex-buttons">
                    <div class="integrantes-action">
                      <ng-container *ngIf="modificarButtons && canEdit">
                        <rpe-ui-button (onClick)="modificarEmpresa()" [bg_blue]="true"
                          [disabled]="entidadProductiva.estado !== 3">Modificar</rpe-ui-button>
                      </ng-container>
                    </div>
                    <div class="actions">
                      <rpe-ui-button (onClick)="downloadEmpresaFile()" [bg_blue]="true">Descargar</rpe-ui-button>
                    </div>
                  </div>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="createdPersonaJuridica"
                    [dataOption]="personaJuridicaPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="createdPersonaFisica" [title]="'Persona Fisica'"
                    [dataOption]="personaFisicaPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail
                    [dataOption]="entidadProductivaPayload"></rpe-entity-mis-empresas-datos-detail>
                </mat-tab>
                <mat-tab label="Depósitos y dependencias" *ngIf="createdPersonaJuridica">
                  <div class="integrantes-action">
                    <ng-container *ngIf="modificarButtons && canEdit">
                      <rpe-ui-button [bg_blue]="true" [disabled]="entidadProductiva.estado !== 3"
                        [routerLink]="'/empresas/mis-actividades'">Modificar</rpe-ui-button>
                    </ng-container>
                  </div>
                  <div class="comercializacion-detalle" *ngIf="entidadProductiva?.persona_juridica_id">
                    <p>
                      <b>Actividades vinculadas exclusivamente a
                        la comercialización:</b> {{entidadProductiva?.exclusivo_comercializacion === null ? 'Sin
                      completar' :
                      entidadProductiva?.exclusivo_comercializacion ? 'Si' : 'No'}}
                    </p>
                    <p *ngIf="entidadProductiva?.exclusivo_comercializacion === false">
                      <b>Comercialización:</b> {{entidadProductiva?.comercializacion ? 'Si' : 'No'}}
                    </p>
                  </div>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="laboratorios.length > 0" [title]="'Laboratorios'"
                    [dataOption]="laboratoriosPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="sitiosProcesamiento.length > 0"
                    [title]="'Sitios procesamiento'"
                    [dataOption]="sitiosProcesamientoPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="maquinasMoviles.length > 0" [title]="'Máquinas móviles'"
                    [dataOption]="maquinasMovilesPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="depositos.length > 0" [title]="'Depósitos'"
                    [dataOption]="depositosPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="viveros.length > 0" [title]="'Viveros'"
                    [dataOption]="viverosPayload"></rpe-entity-mis-empresas-datos-detail>
                </mat-tab>
                <mat-tab label="Integrantes">
                  <div class="integrantes-action">
                    <rpe-ui-button [bg_blue]="true" [disabled]="entidadProductiva.estado !== 3"
                      [routerLink]="'/empresas/mis-integrantes'">Modificar</rpe-ui-button>
                  </div>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="integrantes.length > 0" [title]="'Integrantes'"
                    [dataOption]="integrantesPayload"></rpe-entity-mis-empresas-datos-detail>
                </mat-tab>
                <mat-tab label="Acreditación de certificación" *ngIf="acreditacionEmpresa.length > 0">
                  <rpe-acreditacion-empresa
                    [acreditacionEmpresaInput]="acreditacionEmpresaInput"></rpe-acreditacion-empresa>
                </mat-tab>
              </mat-tab-group>
            </mat-card>
            <!-- Sin mat-card -->
            <ng-container *ngIf="!matCard">
              <mat-tab-group>
                <mat-tab label="Información">
                  <rpe-entity-mis-empresas-datos-detail *ngIf="createdPersonaJuridica"
                    [dataOption]="personaJuridicaPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="createdPersonaFisica" [title]="'Persona Fisica'"
                    [dataOption]="personaFisicaPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail
                    [dataOption]="entidadProductivaPayload"></rpe-entity-mis-empresas-datos-detail>
                </mat-tab>
                <mat-tab label="Depósitos y dependencias" *ngIf="createdPersonaJuridica">
                  <div class="integrantes-action">
                    <button mat-raised-button color="primary" [disabled]="entidadProductiva.estado !== 3"
                      [routerLink]="'/empresas/mis-actividades'" *ngIf="modificarButtons && canEdit">Modificar</button>
                  </div>
                  <div class="comercializacion-detalle" *ngIf="entidadProductiva?.persona_juridica_id">
                    <p>
                      <b>Actividades vinculadas exclusivamente a
                        la comercialización:</b> {{entidadProductiva?.exclusivo_comercializacion === null ? 'Sin
                      completar' :
                      entidadProductiva?.exclusivo_comercializacion ? 'Si' : 'No'}}
                    </p>
                    <p *ngIf="entidadProductiva?.exclusivo_comercializacion === false">
                      <b>Comercialización:</b> {{entidadProductiva?.comercializacion ? 'Si' : 'No'}}
                    </p>
                  </div>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="laboratorios.length > 0" [title]="'Laboratorios'"
                    [dataOption]="laboratoriosPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="sitiosProcesamiento.length > 0"
                    [title]="'Sitios procesamiento'"
                    [dataOption]="sitiosProcesamientoPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="maquinasMoviles.length > 0" [title]="'Máquinas móviles'"
                    [dataOption]="maquinasMovilesPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="depositos.length > 0" [title]="'Depósitos'"
                    [dataOption]="depositosPayload"></rpe-entity-mis-empresas-datos-detail>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="viveros.length > 0" [title]="'Viveros'"
                    [dataOption]="viverosPayload"></rpe-entity-mis-empresas-datos-detail>
                </mat-tab>
                <mat-tab label="Integrantes">
                  <div class="integrantes-action">
                    <button mat-raised-button color="primary" [disabled]="entidadProductiva.estado !== 3"
                      [routerLink]="'/empresas/mis-integrantes'" *ngIf="modificarButtons && canEdit">Modificar</button>
                  </div>
                  <rpe-entity-mis-empresas-datos-detail *ngIf="integrantes.length > 0" [title]="'Integrantes'"
                    [dataOption]="integrantesPayload"></rpe-entity-mis-empresas-datos-detail>
                </mat-tab>
              </mat-tab-group>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>